/* Elori — theme.js (vanilla, no dependencies) */
(function () {
  'use strict';

  /* ---------- Sticky header shadow ---------- */
  var header = document.querySelector('[data-sticky-header]');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-stuck', window.scrollY > 8);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Mobile menu toggle ---------- */
  document.querySelectorAll('[data-menu-toggle]').forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      var menu = document.querySelector('[data-mobile-menu]');
      if (!menu) return;
      var open = menu.hasAttribute('hidden');
      if (open) {
        menu.removeAttribute('hidden');
      } else {
        menu.setAttribute('hidden', '');
      }
      toggle.setAttribute('aria-expanded', String(open));
    });
  });

  /* ---------- FAQ accordion ----------
     Finding the panel used to be trigger.parentElement.querySelector(), which
     assumed the trigger sat exactly one level above its panel. Wrapping the
     button in a heading for document-outline semantics broke that assumption
     and silently disabled every accordion — parentElement became the <h3>,
     which doesn't contain the panel, so the handler returned and nothing moved.

     Now it resolves aria-controls first, and otherwise walks up to the
     accordion root looking for the panel. Markup can nest however it likes. */
  document.querySelectorAll('[data-accordion]').forEach(function (accordion) {
    accordion.querySelectorAll('[data-accordion-trigger]').forEach(function (trigger) {
      var findPanel = function () {
        var panelId = trigger.getAttribute('aria-controls');
        if (panelId) {
          var byId = document.getElementById(panelId);
          if (byId) return byId;
        }
        var node = trigger.parentElement;
        while (node && node !== accordion.parentElement) {
          var found = node.querySelector('[data-accordion-panel]');
          if (found) return found;
          node = node.parentElement;
        }
        return null;
      };

      trigger.addEventListener('click', function () {
        var panel = findPanel();
        if (!panel) return;
        var open = trigger.getAttribute('aria-expanded') === 'true';
        trigger.setAttribute('aria-expanded', String(!open));
        if (open) {
          panel.setAttribute('hidden', '');
        } else {
          panel.removeAttribute('hidden');
        }
      });
    });
  });

  /* ---------- Quantity selectors (delegated) ---------- */
  document.addEventListener('click', function (event) {
    var minus = event.target.closest('[data-qty-minus]');
    var plus = event.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;
    var wrapper = event.target.closest('[data-quantity-selector]');
    if (!wrapper) return;
    var input = wrapper.querySelector('[data-qty-input]');
    if (!input || input.disabled) return;
    var value = parseInt(input.value, 10) || 0;
    var min = parseInt(input.min, 10);
    if (plus) value += 1;
    if (minus) value -= 1;
    if (!isNaN(min)) value = Math.max(min, value);
    input.value = value;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Product gallery thumbs ---------- */
  document.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var gallery = thumb.closest('.main-product__gallery');
      var main = gallery ? gallery.querySelector('[data-gallery-image]') : null;
      if (!main || !thumb.dataset.full) return;
      main.src = thumb.dataset.full;
      gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
        t.classList.toggle('is-active', t === thumb);
      });
    });
  });

  /* ---------- Variant picker ---------- */
  document.querySelectorAll('form[data-product-form]').forEach(function (form) {
    var section = form.closest('.main-product');
    var jsonEl = section ? section.querySelector('[data-variants-json]') : null;
    if (!jsonEl) return;

    var variants;
    try {
      variants = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return;
    }

    form.addEventListener('change', function (event) {
      if (!event.target.matches('[data-option-input]')) return;
      var selected = [];
      var groups = {};
      form.querySelectorAll('[data-option-input]').forEach(function (input) {
        var pos = input.name.replace('option-', '');
        if (input.checked) groups[pos] = input.value;
      });
      Object.keys(groups)
        .sort()
        .forEach(function (pos) {
          selected.push(groups[pos]);
        });

      /* Name the chosen value beside its label. Driven off the checked input
         rather than the matched variant, so it still updates when the
         combination doesn't exist and the buy button goes to "Unavailable". */
      Object.keys(groups).forEach(function (pos) {
        var readout = form.querySelector('[data-option-selected="' + pos + '"]');
        if (!readout) return;
        /* Prefer the marketing name the input carries; fall back to the raw
           variant value so an unmapped option still names itself. */
        var checked = form.querySelector('[name="option-' + pos + '"]:checked');
        readout.textContent =
          (checked && checked.getAttribute('data-display-name')) || groups[pos];
      });

      var match = variants.find(function (variant) {
        return variant.options.every(function (option, index) {
          return option === selected[index];
        });
      });

      var idInput = form.querySelector('[data-variant-id]');
      var button = form.querySelector('[data-add-to-cart]');
      if (match) {
        if (idInput) idInput.value = match.id;
        if (button) {
          button.disabled = !match.available;
          button.textContent = match.available
            ? button.dataset.labelAdd || 'Add to cart'
            : 'Sold out';
        }
        if (match.featured_image && match.featured_image.src) {
          var mainImage = section ? section.querySelector('[data-gallery-image]') : null;
          if (mainImage) {
            mainImage.src = match.featured_image.src;
            if (match.featured_image.alt) mainImage.alt = match.featured_image.alt;
            var matchPath = match.featured_image.src.split('?')[0];
            section.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
              thumb.classList.toggle('is-active', (thumb.dataset.full || '').split('?')[0] === matchPath);
            });
          }
        }
      } else {
        if (button) {
          button.disabled = true;
          button.textContent = 'Unavailable';
        }
      }
    });

    var addButton = form.querySelector('[data-add-to-cart]');
    if (addButton) addButton.dataset.labelAdd = addButton.textContent.trim();
  });

  /* ---------- AJAX add to cart (graceful fallback) ---------- */
  var openCartDrawer = null; // assigned by the cart drawer block below when present

  document.querySelectorAll('form[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (event) {
      if (!window.fetch) return; // fall back to normal submit
      event.preventDefault();

      var button = form.querySelector('[data-add-to-cart]');
      if (button) button.disabled = true;

      /* The free gifts, added after the board and never with it.

         A single request carrying board and gifts together is atomic: if a
         gift is out of stock the whole call fails and nobody can buy the
         board. Sending the gifts separately, and swallowing the failure, means
         a stock-out costs a gift rather than a sale.

         Two kinds. The socks are matched to the colour of the board and carry
         their own price, zeroed by an automatic discount in Shopify. The
         guides are files priced at zero, so nothing has to be applied to them
         and no discount being suppressed can affect them.

         Each gift carries a _gift property. The underscore keeps it off the
         order confirmation and the packing slip, and the cart drawer reads it
         to render the line as a gift rather than as something to adjust.
         Marking it here rather than inferring a zero price means the drawer is
         right even in the moment before Shopify applies the discount. */
      var readJSON = function (el, fallback) {
        if (!el) return fallback;
        try {
          return JSON.parse(el.textContent);
        } catch (e) {
          return fallback;
        }
      };

      var addGifts = function () {
        var host = form.closest('.main-product');
        if (!host) return Promise.resolve();

        var map = readJSON(host.querySelector('[data-gift-variants]'), {});
        var extras = readJSON(host.querySelector('[data-gift-extras]'), []);

        var qtyField = form.querySelector('[name="quantity"]');
        var qty = parseInt(qtyField && qtyField.value, 10) || 1;

        var line = function (id) {
          return { id: id, quantity: qty, properties: { _gift: 'yes' } };
        };

        /* Every checked option is tried against the map rather than assuming
           the colour is the first one. Add a size to the board later and this
           still finds Purple instead of looking up "Large" and giving up. */
        var matched = null;
        form.querySelectorAll('[data-option-input]:checked').forEach(function (input) {
          if (!matched && map[input.value]) matched = map[input.value];
        });

        var fixed = extras.map(line);
        var all = matched ? [line(matched)].concat(fixed) : fixed;
        if (!all.length) return Promise.resolve();

        var send = function (items) {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: items })
          }).then(function (response) {
            if (!response.ok) throw new Error('gift add failed');
            return response;
          });
        };

        return send(all).catch(function () {
          /* One request for all of them keeps add-to-cart at three round
             trips, but it fails as a unit — and the only gift that can run out
             is the physical one. So if it fails, try again without it rather
             than letting a sock stock-out take the guides down with it. */
          if (!matched || !fixed.length) return;
          return send(fixed).catch(function () {});
        });
      };

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Add to cart failed');
          return addGifts();
        })
        .then(function () {
          return fetch('/cart.js', { headers: { Accept: 'application/json' } });
        })
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
            el.setAttribute('data-count', cart.item_count);
          });
          if (openCartDrawer) {
            if (button) button.disabled = false;
            openCartDrawer(cart);
          } else {
            window.location.href = '/cart';
          }
        })
        .catch(function () {
          // Graceful fallback: submit the form the classic way.
          form.submit();
        });
    });
  });

  /* ---------- Login: recover password toggle ---------- */
  document.querySelectorAll('[data-recover-toggle]').forEach(function (link) {
    link.addEventListener('click', function (event) {
      event.preventDefault();
      var target = document.getElementById('recover');
      if (target) target.removeAttribute('hidden');
    });
  });

  /* ---------- Cart drawer ---------- */
  /* Delegated + lazy lookups so it keeps working after theme-editor section reloads. */
  if (window.fetch) {
    var drawerHideTimer = null;
    var drawerLastFocused = null;

    var getDrawer = function () {
      return document.querySelector('[data-cart-drawer]');
    };

    var formatDrawerMoney = function (drawer, cents) {
      var format = drawer.dataset.moneyFormat || '${{amount}}';
      var amount = (cents / 100).toFixed(2);
      return format.replace(/\{\{\s*amount[^}]*\}\}/, amount);
    };

    /* Word rather than a zero. Read off the drawer so it stays translatable
       and editable, with a sensible value if the attribute is missing. */
    var giftLabel = function (drawer) {
      return drawer.dataset.giftLabel || 'Free';
    };

    /* Suppressed while a colour swap is mid-flight. A swap briefly puts two
       gift lines in the cart, which can leave one of them charged for a
       moment — the guard below must not read that as a broken bundle and
       throw the gifts out from under the customer. */
    var giftGuardPaused = false;

    var isGift = function (item) {
      return !!(item.properties && item.properties._gift);
    };

    /* Gifts exist alongside a purchase, and only while they are actually
       free. Two ways that stops being true:

       - the board goes, leaving gifts with nothing to be a gift with
       - the discount stops covering them, because a customer removed one of
         the three the offer requires

       Either way the answer is the same and it is not to leave a charge in
       the cart. Taking one gift out takes them all out, which reads as
       declining the bundle rather than as a penalty, and it is the only
       outcome that cannot end in someone paying for something the page
       called free. */
    var enforceGiftRules = function (cart) {
      if (giftGuardPaused) return false;

      var gifts = cart.items.filter(isGift);
      if (!gifts.length) return false;

      var orphaned = cart.items.filter(function (item) {
        return !isGift(item);
      }).length === 0;
      var charged = gifts.some(function (item) {
        return item.final_line_price > 0;
      });
      if (!orphaned && !charged) return false;

      /* By key, not by line number: every removal renumbers the ones after
         it, so a second call against a stale index removes the wrong line. */
      var keys = gifts.map(function (item) {
        return item.key;
      });

      keys
        .reduce(function (chain, key) {
          return chain.then(function () {
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: key, quantity: 0 })
            });
          });
        }, Promise.resolve())
        .then(function () {
          return fetch('/cart.js', { headers: { Accept: 'application/json' } });
        })
        .then(function (response) {
          return response.json();
        })
        .then(renderDrawer)
        .catch(function () {});

      return true;
    };

    /* Shopify hands back the gifts first and the board last, whatever order
       things went in. The thing being bought leads. */
    var orderedLines = function (cart) {
      var lines = cart.items.map(function (item, index) {
        return { item: item, line: index + 1 };
      });
      var bought = lines.filter(function (entry) {
        return !isGift(entry.item);
      });
      var given = lines.filter(function (entry) {
        return isGift(entry.item);
      });
      return bought.concat(given);
    };

    var renderDrawer = function (cart) {
      if (enforceGiftRules(cart)) return;

      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
        el.setAttribute('data-count', cart.item_count);
      });

      var drawer = getDrawer();
      if (!drawer) return;
      var itemsWrap = drawer.querySelector('[data-cart-drawer-items]');
      var emptyEl = drawer.querySelector('[data-cart-drawer-empty]');
      var footerEl = drawer.querySelector('[data-cart-drawer-footer]');
      var subtotalEl = drawer.querySelector('[data-cart-drawer-subtotal]');
      var lineTemplate = drawer.querySelector('[data-cart-drawer-line-template]');
      if (!itemsWrap || !lineTemplate) return;

      itemsWrap.innerHTML = '';

      if (!cart.items.length) {
        if (emptyEl) emptyEl.removeAttribute('hidden');
        if (footerEl) footerEl.setAttribute('hidden', '');
        return;
      }
      if (emptyEl) emptyEl.setAttribute('hidden', '');
      if (footerEl) footerEl.removeAttribute('hidden');

      /* Parsed once per render rather than per line. A malformed or absent map
         just means no was-prices, so a bad attribute can't break the drawer. */
      var comparePrices = {};
      try {
        comparePrices = JSON.parse(drawer.dataset.comparePrices || '{}');
      } catch (e) {
        comparePrices = {};
      }

      /* Colour name to variant id for the gift that has colours. Parsed once
         per render rather than per line, and a malformed attribute simply
         means no swatches — it can't break the drawer. */
      var giftSwatches = {};
      try {
        giftSwatches = JSON.parse(drawer.dataset.giftSwatches || '{}');
      } catch (e) {
        giftSwatches = {};
      }
      var swatchNames = Object.keys(giftSwatches);
      var swatchIds = swatchNames.map(function (name) {
        return giftSwatches[name];
      });
      var savedTotal = 0;

      orderedLines(cart).forEach(function (entry) {
        var item = entry.item;
        var node = lineTemplate.content.cloneNode(true);
        var image = node.querySelector('[data-line-image]');
        var title = node.querySelector('[data-line-title]');
        var variant = node.querySelector('[data-line-variant]');
        var price = node.querySelector('[data-line-price]');
        var qtyInput = node.querySelector('[data-qty-input]');
        var removeButton = node.querySelector('[data-drawer-remove]');

        if (image) {
          if (item.image) {
            image.src = item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=160';
            image.alt = item.product_title;
          } else {
            image.remove();
          }
        }
        if (title) title.textContent = item.product_title;
        if (variant) {
          if (item.variant_title) {
            variant.textContent = item.variant_title;
          } else {
            variant.remove();
          }
        }
        if (price) price.textContent = formatDrawerMoney(drawer, item.final_line_price);

        /* The was-price, from whichever of two places actually holds it.

           A gift priced at zero has its worth in compare_at_price, which the
           cart API does not return — hence the Liquid map. A gift still
           carrying its price and zeroed by a discount has no compare_at at
           all; its worth is the original line price, which the API does
           return. The socks are the second kind and the guides the first, so
           reading only one source left one of them looking like it came free
           out of nowhere.

           Both are line totals, so they line up with the figure beside them
           rather than with a unit price. */
        var compare = node.querySelector('[data-line-compare]');
        if (compare) {
          var wasUnit = comparePrices[item.variant_id];
          var wasLine = wasUnit ? wasUnit * item.quantity : 0;
          if (wasLine <= item.final_line_price && item.original_line_price > item.final_line_price) {
            wasLine = item.original_line_price;
          }

          if (wasLine > item.final_line_price) {
            compare.textContent = formatDrawerMoney(drawer, wasLine);
            compare.removeAttribute('hidden');
            savedTotal += wasLine - item.final_line_price;
          } else {
            compare.remove();
          }
        }
        if (qtyInput) {
          qtyInput.value = item.quantity;
          qtyInput.dataset.line = entry.line;
        }
        if (removeButton) removeButton.dataset.line = entry.line;

        /* A gift line: the stepper comes out and the price reads Free rather
           than a zero. The remove button stays — a line you cannot delete is
           a cart that will not do as it is told, and someone who does not
           want the socks is entitled to say so.

           The stepper is the part that goes, because raising the quantity on
           a discounted line is how you end up giving away three pairs.

           Both conditions have to hold. The property says what the line was
           added as, not what it costs; if a discount has not fired, the
           honest thing is the real price. A cart that prints Free beside a
           charge is worse than one that prints the charge, and it hides
           exactly the fault it should be surfacing. */
        if (item.properties && item.properties._gift && item.final_line_price === 0) {
          var line = node.querySelector('.cart-drawer__line');
          if (line) line.classList.add('cart-drawer__line--gift');
          var stepper = node.querySelector('[data-quantity-selector]');
          if (stepper) stepper.remove();
          if (price) price.textContent = giftLabel(drawer);
        }

        /* Colours, on the one gift that has them.

           Deliberately outside the test above. Whether a discount has fired
           has nothing to do with whether somebody wants pink, and a control
           that disappears when the price is wrong takes away the fix at the
           moment it is most wanted. The board's colour is already the one in
           the cart, so the selected swatch is whichever variant is actually
           there rather than a guess. */
        var swatchWrap = node.querySelector('[data-line-swatches]');
        if (
          swatchWrap &&
          item.properties &&
          item.properties._gift &&
          swatchIds.indexOf(item.variant_id) > -1
        ) {
          swatchNames.forEach(function (name) {
            var id = giftSwatches[name];
            var button = document.createElement('button');
            button.type = 'button';
            button.className =
              'cart-drawer__line-swatch swatch swatch--' + name.toLowerCase().replace(/\s+/g, '-');
            button.setAttribute('data-gift-swap', id);
            button.setAttribute('data-line-key', item.key);
            button.setAttribute('aria-label', name);
            /* aria-pressed, not a class alone: the state has to reach a screen
               reader, not only the eye. */
            button.setAttribute('aria-pressed', String(id === item.variant_id));
            if (id === item.variant_id) button.classList.add('is-selected');
            swatchWrap.appendChild(button);
          });
          swatchWrap.removeAttribute('hidden');
        }

        itemsWrap.appendChild(node);
      });

      if (subtotalEl) subtotalEl.textContent = formatDrawerMoney(drawer, cart.total_price);

      /* Accumulated across the lines above. Hidden at zero rather than showing
         "You're saving $0.00", which reads worse than showing nothing. */
      var savingEl = drawer.querySelector('[data-cart-drawer-saving]');
      var savingAmount = drawer.querySelector('[data-cart-drawer-saving-amount]');
      if (savingEl && savingAmount) {
        if (savedTotal > 0) {
          savingAmount.textContent = formatDrawerMoney(drawer, savedTotal);
          savingEl.removeAttribute('hidden');
        } else {
          savingEl.setAttribute('hidden', '');
        }
      }
    };

    var openDrawer = function () {
      var drawer = getDrawer();
      if (!drawer) return false;
      clearTimeout(drawerHideTimer);
      drawerLastFocused = document.activeElement;
      drawer.removeAttribute('hidden');
      requestAnimationFrame(function () {
        drawer.classList.add('is-open');
      });
      document.body.classList.add('drawer-open');
      var closeButton = drawer.querySelector('[data-cart-drawer-close-button]');
      if (closeButton) closeButton.focus();
      return true;
    };

    var closeDrawer = function () {
      var drawer = getDrawer();
      if (!drawer) return;
      drawer.classList.remove('is-open');
      document.body.classList.remove('drawer-open');
      drawerHideTimer = setTimeout(function () {
        drawer.setAttribute('hidden', '');
      }, 300);
      if (drawerLastFocused && document.body.contains(drawerLastFocused)) {
        drawerLastFocused.focus();
      }
    };

    /* Swapping a gift's colour.

       Shopify cannot change the variant on a line, so a swap is really an add
       and a remove. It adds first: if the second call fails the customer ends
       up with a spare pair rather than none, and a spare is recoverable from
       the drawer while a missing gift is not.

       The whole strip is disabled while it runs. Two taps would otherwise
       start two swaps against the same line key, and the second remove would
       fail against a line that had already gone. */
    var swapGiftColour = function (drawer, lineKey, variantId, quantity) {
      var strip = drawer.querySelectorAll('[data-gift-swap]');
      strip.forEach(function (button) {
        button.disabled = true;
      });
      giftGuardPaused = true;

      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: quantity, properties: { _gift: 'yes' } }]
        })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('could not add the new colour');
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: lineKey, quantity: 0 })
          });
        })
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          giftGuardPaused = false;
          renderDrawer(cart);
        })
        .catch(function () {
          giftGuardPaused = false;
          /* Re-read rather than guess. Whatever went wrong, the drawer should
             show what is actually in the cart. */
          fetch('/cart.js', { headers: { Accept: 'application/json' } })
            .then(function (response) {
              return response.json();
            })
            .then(renderDrawer)
            .catch(function () {});
        });
    };

    var changeDrawerLine = function (line, quantity) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then(function (response) {
          return response.json();
        })
        .then(renderDrawer)
        .catch(function () {});
    };

    openCartDrawer = function (cart) {
      if (!getDrawer()) {
        window.location.href = '/cart';
        return;
      }
      renderDrawer(cart);
      openDrawer();
    };

    document.addEventListener('click', function (event) {
      var opener = event.target.closest('[data-cart-drawer-open]');
      if (opener) {
        if (!getDrawer()) return; // fall through to the normal /cart link
        event.preventDefault();
        fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (response) {
            return response.json();
          })
          .then(openCartDrawer)
          .catch(function () {
            window.location.href = opener.href || '/cart';
          });
        return;
      }

      var drawer = getDrawer();
      if (!drawer || drawer.hasAttribute('hidden')) return;

      if (event.target.closest('[data-cart-drawer-close]')) {
        closeDrawer();
        return;
      }
      var removeButton = event.target.closest('[data-drawer-remove]');
      if (removeButton && removeButton.dataset.line) {
        changeDrawerLine(parseInt(removeButton.dataset.line, 10), 0);
        return;
      }

      var swatch = event.target.closest('[data-gift-swap]');
      if (swatch && !swatch.disabled && swatch.getAttribute('aria-pressed') !== 'true') {
        var lineEl = swatch.closest('.cart-drawer__line');
        var qtyEl = lineEl ? lineEl.querySelector('[data-qty-input]') : null;
        swapGiftColour(
          drawer,
          swatch.dataset.lineKey,
          parseInt(swatch.dataset.giftSwap, 10),
          parseInt(qtyEl && qtyEl.value, 10) || 1
        );
      }
    });

    document.addEventListener('change', function (event) {
      var input = event.target.closest('[data-cart-drawer] [data-qty-input]');
      if (!input || !input.dataset.line) return;
      changeDrawerLine(parseInt(input.dataset.line, 10), parseInt(input.value, 10) || 0);
    });

    document.addEventListener('keydown', function (event) {
      var drawer = getDrawer();
      if (!drawer || drawer.hasAttribute('hidden')) return;
      if (event.key === 'Escape') {
        closeDrawer();
        return;
      }
      if (event.key === 'Tab') {
        var panel = drawer.querySelector('[data-cart-drawer-panel]');
        if (!panel) return;
        var focusable = panel.querySelectorAll(
          'button:not([disabled]), a[href], input:not([disabled])'
        );
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    });
  }

  /* ---------- Sticky add to cart ---------- */
  document.querySelectorAll('[data-sticky-atc]').forEach(function (bar) {
    var productSection = bar.closest('.main-product');
    if (!productSection) return;
    var buyRow = productSection.querySelector('.main-product__buy-row');
    var productForm = productSection.querySelector('form[data-product-form]');
    var mainButton = productSection.querySelector('[data-add-to-cart]');
    var stickyButton = bar.querySelector('[data-sticky-add]');
    if (!buyRow || !productForm || !stickyButton || !('IntersectionObserver' in window)) return;

    bar.removeAttribute('hidden');

    /* Two conditions, tracked separately and combined on every change.

       The bar belongs on screen once the real buy button has scrolled past,
       and it stops belonging there once the footer arrives — a fixed bar over
       the footer hides the policies, the contact address and the copyright,
       which are the things somebody who has scrolled that far is looking for.
       It pulls itself out of the way rather than covering them. */
    var scrolledPast = false;
    var atFooter = false;

    var sync = function () {
      bar.classList.toggle('is-visible', scrolledPast && !atFooter);
    };

    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      });
      sync();
    }).observe(buyRow);

    var footer = document.querySelector('.site-footer');
    if (footer) {
      /* A margin the height of the bar, so it retreats as the footer reaches
         it rather than once the footer is already behind it. */
      new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            atFooter = entry.isIntersecting;
          });
          sync();
        },
        { rootMargin: '0px 0px -' + Math.round(bar.offsetHeight) + 'px 0px' }
      ).observe(footer);
    }

    stickyButton.addEventListener('click', function () {
      if (productForm.requestSubmit) {
        productForm.requestSubmit();
      } else {
        productForm.submit();
      }
    });

    if (mainButton) {
      var syncSticky = function () {
        stickyButton.disabled = mainButton.disabled;
        stickyButton.textContent = mainButton.textContent.trim();
      };
      new MutationObserver(syncSticky).observe(mainButton, {
        attributes: true,
        childList: true,
        characterData: true,
        subtree: true
      });
      syncSticky();
    }
  });

  /* ---------- Announcement bar rotator ---------- */
  document.querySelectorAll('[data-announcement-rotator]').forEach(function (rotator) {
    var messages = rotator.querySelectorAll('.announcement-bar__message');
    if (messages.length < 2) return;
    var current = 0;
    messages[current].classList.add('is-active');
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    setInterval(function () {
      messages[current].classList.remove('is-active');
      current = (current + 1) % messages.length;
      messages[current].classList.add('is-active');
    }, 4000);
  });

  /* ---------- Countdown timers ---------- */
  var padTime = function (n) {
    return String(n).padStart(2, '0');
  };

  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var wrap = el.closest('[data-countdown-wrap]') || el;
    var mode = el.dataset.countdownMode || 'daily';
    var fixedEnd = null;
    if (mode === 'fixed') {
      fixedEnd = new Date(el.dataset.countdownEnd);
      if (isNaN(fixedEnd.getTime())) return; // wrapper stays hidden
    }

    var timer;
    var tick = function () {
      var now = new Date();
      var end;
      if (mode === 'daily') {
        end = new Date(now);
        end.setHours(24, 0, 0, 0);
      } else {
        end = fixedEnd;
        if (end - now <= 0) {
          wrap.setAttribute('hidden', '');
          clearInterval(timer);
          return;
        }
      }
      var diff = Math.max(0, end - now);
      var days = Math.floor(diff / 86400000);
      var hours = Math.floor(diff / 3600000) % 24;
      var mins = Math.floor(diff / 60000) % 60;
      var secs = Math.floor(diff / 1000) % 60;
      el.textContent = (days > 0 ? days + 'd ' : '') + padTime(hours) + ':' + padTime(mins) + ':' + padTime(secs);
      wrap.removeAttribute('hidden');
    };
    tick();
    timer = setInterval(tick, 1000);
  });

  /* ---------- Dispatch estimate ---------- */
  document.querySelectorAll('[data-dispatch-estimate]').forEach(function (el) {
    var textEl = el.querySelector('[data-dispatch-text]');
    if (!textEl) return;
    var template = el.dataset.template || 'Order within {time} and your order ships by {date}.';
    var mode = el.dataset.dispatchMode || 'cutoff';
    var cutoffHour = parseInt(el.dataset.cutoffHour, 10);
    if (isNaN(cutoffHour)) cutoffHour = 14;
    var dispatchDays = parseInt(el.dataset.dispatchDays, 10) || 2;

    var skipWeekend = function (date) {
      while (date.getDay() === 0 || date.getDay() === 6) {
        date.setDate(date.getDate() + 1);
      }
      return date;
    };

    var tick = function () {
      var now = new Date();
      if (mode === 'midnight') {
        /* Countdown to the visitor's local midnight — order today, ships tomorrow. */
        var end = new Date(now);
        end.setHours(24, 0, 0, 0);
        var remaining = Math.max(0, end - now);
        var h = Math.floor(remaining / 3600000);
        var m = Math.floor(remaining / 60000) % 60;
        var s = Math.floor(remaining / 1000) % 60;
        textEl.textContent = template
          .replace('{time}', padTime(h) + ':' + padTime(m) + ':' + padTime(s))
          .replace('{date}', '');
        el.removeAttribute('hidden');
        return;
      }

      var cutoff = new Date(now);
      cutoff.setHours(cutoffHour, 0, 0, 0);
      if (cutoff <= now) cutoff.setDate(cutoff.getDate() + 1);
      skipWeekend(cutoff);

      var ship = new Date(cutoff);
      ship.setDate(ship.getDate() + dispatchDays);
      skipWeekend(ship);

      var diff = cutoff - now;
      var hours = Math.floor(diff / 3600000);
      var mins = Math.floor(diff / 60000) % 60;
      var time = (hours > 0 ? hours + 'h ' : '') + mins + 'm';
      var date = ship.toLocaleDateString(undefined, { weekday: 'long', month: 'short', day: 'numeric' });
      textEl.textContent = template.replace('{time}', time).replace('{date}', date);
      el.removeAttribute('hidden');
    };
    tick();
    setInterval(tick, mode === 'midnight' ? 1000 : 30000);
  });

  /* ---------- Discount popup ---------- */
  var popup = document.querySelector('[data-discount-popup]');
  if (popup) {
    var POPUP_KEY = 'elori:discount-popup';
    var readPopupState = function () {
      try {
        return JSON.parse(localStorage.getItem(POPUP_KEY)) || {};
      } catch (e) {
        return {};
      }
    };
    var writePopupState = function (state) {
      try {
        localStorage.setItem(POPUP_KEY, JSON.stringify(state));
      } catch (e) {
        /* private mode — popup just shows again next visit */
      }
    };

    var popupLastFocused = null;
    var popupHideTimer = null;
    var popupDelayTimer = null;
    var reminder = document.querySelector('[data-discount-reminder]');

    var syncReminder = function () {
      if (!reminder) return;
      var state = readPopupState();
      if (state.done && !state.reminderDismissed) {
        reminder.removeAttribute('hidden');
      }
    };

    var openPopup = function () {
      clearTimeout(popupHideTimer);
      popupLastFocused = document.activeElement;
      popup.removeAttribute('hidden');
      requestAnimationFrame(function () {
        popup.classList.add('is-open');
      });
      document.body.classList.add('popup-open');
      var closeButton = popup.querySelector('[data-popup-close-button]');
      if (closeButton) closeButton.focus();
    };

    var closePopup = function () {
      popup.classList.remove('is-open');
      document.body.classList.remove('popup-open');
      popupHideTimer = setTimeout(function () {
        popup.setAttribute('hidden', '');
      }, 250);
      var state = readPopupState();
      if (!state.done) {
        state.dismissedAt = Date.now();
        writePopupState(state);
      }
      if (popupLastFocused && document.body.contains(popupLastFocused)) {
        popupLastFocused.focus();
      }
      syncReminder();
    };

    if (reminder) {
      reminder.addEventListener('click', function (event) {
        if (event.target.closest('[data-reminder-close]')) {
          reminder.setAttribute('hidden', '');
          var state = readPopupState();
          state.reminderDismissed = true;
          writePopupState(state);
        }
      });
    }

    popup.addEventListener('click', function (event) {
      if (event.target.closest('[data-popup-close]')) {
        closePopup();
        return;
      }
      var copyButton = event.target.closest('[data-popup-copy]');
      if (copyButton) {
        var code = popup.querySelector('[data-popup-code]');
        if (code && navigator.clipboard) {
          navigator.clipboard.writeText(code.textContent.trim()).then(function () {
            copyButton.textContent = copyButton.dataset.labelCopied || 'Copied!';
          });
        }
      }
    });

    document.addEventListener('keydown', function (event) {
      if (popup.hasAttribute('hidden')) return;
      if (event.key === 'Escape') {
        closePopup();
        return;
      }
      if (event.key === 'Tab') {
        var panel = popup.querySelector('[data-popup-panel]');
        if (!panel) return;
        var focusable = panel.querySelectorAll('button:not([disabled]), a[href], input:not([disabled])');
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    });

    if (window.Shopify && window.Shopify.designMode) {
      // Theme editor: open only when the merchant selects the section.
      document.addEventListener('shopify:section:select', function (event) {
        if (event.target.contains(popup)) openPopup();
      });
      document.addEventListener('shopify:section:deselect', function (event) {
        if (event.target.contains(popup)) closePopup();
      });
    } else if (popup.querySelector('[data-popup-revealed]')) {
      // Back from a successful signup: show the code, never nag again.
      writePopupState({ done: true });
      openPopup();
    } else {
      var popupState = readPopupState();
      if (popupState.done) {
        syncReminder();
      } else {
        var daysHidden = parseFloat(popup.dataset.daysHidden) || 7;
        var hiddenUntil = (popupState.dismissedAt || 0) + daysHidden * 86400000;
        if (Date.now() > hiddenUntil) {
          var maybeOpenPopup = function () {
            if (popup.classList.contains('was-shown')) return;
            popup.classList.add('was-shown');
            clearTimeout(popupDelayTimer);
            openPopup();
          };
          popupDelayTimer = setTimeout(maybeOpenPopup, (parseFloat(popup.dataset.delay) || 6) * 1000);
          if (popup.dataset.exitIntent === 'true') {
            document.addEventListener('mouseout', function (event) {
              if (!event.relatedTarget && event.clientY <= 0) maybeOpenPopup();
            });
          }
        }
      }
    }
  }
})();

/* Elori — theme.js: sections added in the editorial pass */
(function () {
  'use strict';

  /* ---------- Before / after slider ----------
     The range input is the source of truth. All this does is mirror its value
     onto a custom property the CSS clip-path reads, so keyboard, touch and
     mouse all work through one code path. */
  document.querySelectorAll('[data-before-after]').forEach(function (frame) {
    var input = frame.querySelector('[data-before-after-input]');
    if (!input) return;

    var sync = function () {
      frame.style.setProperty('--reveal', input.value + '%');
    };

    input.addEventListener('input', sync);
    input.addEventListener('change', sync);
    sync();
  });

  /* ---------- Video facade ----------
     Swap the poster for a real player only once the visitor asks for it, so
     no third-party iframe loads on pages nobody watches. */
  document.querySelectorAll('[data-video-facade]').forEach(function (facade) {
    var trigger = facade.querySelector('[data-video-play]');
    if (!trigger) return;

    var play = function () {
      var type = facade.dataset.videoType;
      var id = facade.dataset.videoId;
      if (!type || !id) return;

      var src;
      if (type === 'youtube') {
        src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0&playsinline=1';
      } else if (type === 'vimeo') {
        src = 'https://player.vimeo.com/video/' + id + '?autoplay=1';
      } else {
        return;
      }

      var iframe = document.createElement('iframe');
      iframe.setAttribute('src', src);
      iframe.setAttribute('title', facade.dataset.videoTitle || 'Video');
      iframe.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture');
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('loading', 'lazy');

      var frame = facade.parentElement;
      facade.remove();
      frame.appendChild(iframe);
      iframe.focus();
    };

    trigger.addEventListener('click', play);
  });

  /* ---------- Collection sort ----------
     Submit on change so the control behaves like a filter, not a form. The
     no-JS path keeps its own visible Apply button. */
  document.querySelectorAll('[data-sort-select]').forEach(function (select) {
    var form = select.closest('form');
    if (!form) return;
    var fallback = form.querySelector('[data-sort-submit]');
    if (fallback) fallback.hidden = true;
    select.addEventListener('change', function () {
      form.submit();
    });
  });

  /* ---------- Filter drawer (collection, small screens) ---------- */
  document.querySelectorAll('[data-filter-toggle]').forEach(function (toggle) {
    var panelId = toggle.getAttribute('aria-controls');
    var panel = panelId ? document.getElementById(panelId) : null;
    if (!panel) return;

    toggle.addEventListener('click', function () {
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      panel.toggleAttribute('hidden', open);
    });
  });
})();

/* Elori — theme.js: discount popup qualifying step */
(function () {
  'use strict';

  var popupRoot = document.querySelector('[data-discount-popup]');
  if (!popupRoot) return;

  var questionStep = popupRoot.querySelector('[data-popup-step="question"]');
  var emailStep = popupRoot.querySelector('[data-popup-step="email"]');
  if (!questionStep || !emailStep) return;

  popupRoot.addEventListener('click', function (event) {
    var option = event.target.closest('[data-popup-option]');
    if (!option) return;

    /* Ride the answer along on the customer's tags so it's available for
       segmentation later, rather than being thrown away at the step boundary. */
    var tags = popupRoot.querySelector('[data-popup-tags]');
    var value = option.getAttribute('data-value');
    if (tags && value) {
      tags.value = tags.value + ',level-' + value;
    }

    questionStep.setAttribute('hidden', '');
    emailStep.removeAttribute('hidden');

    var field = emailStep.querySelector('[data-popup-email]');
    if (field) field.focus();
  });
})();

/* Elori — theme.js: bundle tier button label */
(function () {
  'use strict';

  document.querySelectorAll('[data-tier-submit]').forEach(function (button) {
    var form = button.closest('form');
    if (!form) return;

    var sync = function () {
      var checked = form.querySelector('input[name="quantity"]:checked');
      var qty = checked ? parseInt(checked.value, 10) : 1;
      if (!qty || qty < 1) qty = 1;

      var single = button.getAttribute('data-label-single') || 'Add to cart';
      var multi = button.getAttribute('data-label-multi') || 'Add [qty] to cart';
      button.textContent = qty > 1 ? multi.replace('[qty]', qty) : single;
    };

    form.addEventListener('change', function (event) {
      if (event.target.name === 'quantity') sync();
    });

    sync();
  });
})();

/* Elori — theme.js: stat row count-up */
(function () {
  'use strict';

  var rows = document.querySelectorAll('[data-stat-row]');
  if (!rows.length) return;

  /* The final value is already in the HTML. If the visitor asked for reduced
     motion, or the browser can't tell us when the row is on screen, we leave
     it exactly as rendered — there is nothing to fall back to because nothing
     was taken away. */
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  /* "$3,228" -> { prefix: "$", target: 3228, suffix: "", decimals: 0, group: true }
     "15 min" -> { prefix: "",  target: 15,   suffix: " min", decimals: 0, group: false }

     decimals and grouping are read off the author's own formatting rather than
     imposed, so "4.9" stays at one decimal place and "3228" never grows a
     comma it wasn't written with. A value containing no number at all returns
     null and is left alone. */
  var parse = function (text) {
    var match = text.match(/^(\D*?)(\d[\d,]*(?:\.\d+)?)(.*)$/);
    if (!match) return null;

    var raw = match[2];
    var dot = raw.indexOf('.');

    return {
      prefix: match[1],
      suffix: match[3],
      target: parseFloat(raw.replace(/,/g, '')),
      decimals: dot === -1 ? 0 : raw.length - dot - 1,
      group: raw.indexOf(',') !== -1
    };
  };

  var format = function (n, spec) {
    return spec.prefix + n.toLocaleString('en-US', {
      minimumFractionDigits: spec.decimals,
      maximumFractionDigits: spec.decimals,
      useGrouping: spec.group
    }) + spec.suffix;
  };

  var DURATION = 1400;

  var animate = function (el, spec) {
    /* Pin the box to the width of the finished number before replacing it with
       a zero. Without this the whole row shuffles sideways on every frame as
       the digit count grows. */
    el.style.minWidth = el.getBoundingClientRect().width + 'px';

    var start = null;

    var step = function (now) {
      if (start === null) start = now;

      var t = Math.min((now - start) / DURATION, 1);
      var eased = 1 - Math.pow(1 - t, 3);

      el.textContent = format(spec.target * eased, spec);

      if (t < 1) {
        requestAnimationFrame(step);
        return;
      }

      /* Land on the authored value rather than whatever the easing rounded to. */
      el.textContent = format(spec.target, spec);
      el.style.minWidth = '';
    };

    el.textContent = format(0, spec);
    requestAnimationFrame(step);
  };

  rows.forEach(function (row) {
    var values = row.querySelectorAll('[data-stat-value]');
    if (!values.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;

        observer.disconnect();

        values.forEach(function (el, index) {
          var spec = parse(el.textContent.trim());
          if (!spec) return;

          /* A small stagger so the row reads left to right instead of four
             numbers twitching in unison. */
          window.setTimeout(function () {
            animate(el, spec);
          }, index * 90);
        });
      });
    }, { threshold: 0.25 });

    observer.observe(row);
  });
})();

/* Elori — theme.js: video reels */
(function () {
  'use strict';

  var sections = document.querySelectorAll('.video-reels');
  if (!sections.length) return;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  sections.forEach(function (section) {
    var track = section.querySelector('[data-reels-track]');
    if (!track) return;

    /* Playback is handled by the inline-clip observer below, which watches
       every muted looping clip on the page rather than only these. */

    var step = function () {
      var item = track.querySelector('.video-reels__item');
      if (!item) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return item.getBoundingClientRect().width + gap;
    };

    /* ---- A constant loop --------------------------------------------------

       The row moves one way at a steady speed and never turns round. That
       needs a second copy of the clips: the drift runs to the end of the first
       set, and at the moment it gets there the scroll position jumps back by
       exactly one set width. What is under the viewport before and after the
       jump is the same clip, so there is nothing to see.

       The copies are in the DOM from the start rather than made on demand,
       which matters: the handler further down that plays a clip while it is on
       screen collects its elements once, at load. Anything added later would
       sit there as a still poster. They are hidden until the row is actually
       looping, so a desktop where all five fit is unaffected — and a hidden
       clip never intersects, so it never plays or downloads.

       Two CSS properties are suspended while it runs. `scroll-snap-type: x
       mandatory` drags the row back to the nearest clip edge after every
       frame, and Safari can win that argument outright. `scroll-behavior:
       smooth` asks the browser to animate its way to each new scrollLeft,
       sixty times a second, each request cancelling the last.

       It yields while the visitor is scrolling and picks up again once they
       stop. What counts as taking over is a sideways drag, not a touch: on a
       phone the page is scrolled by dragging, and this section is over 400px
       tall, so a finger passing down it lands on the track nearly every time.

       It only runs while the section is on screen, and reduced motion turns it
       off altogether. */
    var SPEED = 34; /* px per second — a drift, not a slide */

    var frame = null;
    var lastTime = 0;
    var offset = 0;
    var paused = false;
    var resumeTimer = null;

    var originals = Array.prototype.slice.call(
      track.querySelectorAll('.video-reels__item')
    );

    originals.forEach(function (item) {
      var copy = item.cloneNode(true);
      copy.setAttribute('data-reels-clone', '');
      /* A screen reader should hear five clips, not ten. */
      copy.setAttribute('aria-hidden', 'true');
      track.appendChild(copy);
    });

    var gapWidth = function () {
      return parseFloat(getComputedStyle(track).columnGap) || 0;
    };

    /* Width of one set of clips, measured off the rendered items so it stays
       right when they resize. */
    var setSpan = function () {
      var first = originals[0];
      var last = originals[originals.length - 1];
      if (!first || !last) return 0;
      return last.offsetLeft + last.offsetWidth - first.offsetLeft;
    };

    /* Distance from a clip to its copy — what the jump subtracts. */
    var loopWidth = function () {
      return setSpan() + gapWidth();
    };

    /* Measured on one set, never the doubled row, so revealing the copies
       cannot talk the row into thinking it has somewhere to go. */
    var canSlide = function () {
      return setSpan() - track.clientWidth > 8;
    };

    var tick = function (now) {
      var span = loopWidth();
      if (span <= 0) {
        frame = requestAnimationFrame(tick);
        return;
      }

      /* First frame after starting has no previous timestamp to measure
         against, and a tab restored from the background reports a huge one.
         Either would jump the row instead of moving it. */
      var elapsed = lastTime ? (now - lastTime) / 1000 : 0;
      if (elapsed > 0.1) elapsed = 0.1;
      lastTime = now;

      offset += SPEED * elapsed;
      if (offset >= span) offset -= span;

      track.scrollLeft = offset;
      frame = requestAnimationFrame(tick);
    };

    var stopAuto = function () {
      if (frame) {
        cancelAnimationFrame(frame);
        frame = null;
      }
      lastTime = 0;
      track.classList.remove('video-reels__track--drifting');
    };

    var startAuto = function () {
      if (frame || paused || reduced || !canSlide()) return;
      track.classList.add('video-reels__track--looping');
      /* Pick up wherever the row actually is, so returning to the section
         carries on rather than snapping back. */
      offset = track.scrollLeft;
      var span = loopWidth();
      if (span > 0 && offset >= span) offset -= span;
      lastTime = 0;
      track.classList.add('video-reels__track--drifting');
      frame = requestAnimationFrame(tick);
    };

    /* Handing control over, not giving it up. The drift stops, snapping comes
       back so the swipe behaves like an ordinary scroller, and it picks up
       again from wherever they left it once the row has been still. */
    var pauseAuto = function () {
      paused = true;
      stopAuto();
    };

    /* Momentum keeps firing scroll events long after the finger has gone, and
       resuming into one would mean the drift fighting the flick. Each of those
       events pushes the restart back, so it only happens once the row has
       actually settled. */
    var scheduleResume = function () {
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(function () {
        paused = false;
        startAuto();
      }, 900);
    };

    /* A sideways drag is the visitor taking over. A touch that turns into a
       vertical drag is them scrolling the page, and must not count. */
    var startX = 0;
    var startY = 0;

    track.addEventListener(
      'touchstart',
      function (event) {
        var touch = event.changedTouches[0];
        startX = touch.clientX;
        startY = touch.clientY;
      },
      { passive: true }
    );

    track.addEventListener(
      'touchmove',
      function (event) {
        var touch = event.changedTouches[0];
        var dx = Math.abs(touch.clientX - startX);
        var dy = Math.abs(touch.clientY - startY);
        if (dx > 12 && dx > dy) {
          pauseAuto();
          clearTimeout(resumeTimer);
        }
      },
      { passive: true }
    );

    ['touchend', 'touchcancel'].forEach(function (name) {
      track.addEventListener(
        name,
        function () {
          if (paused) scheduleResume();
        },
        { passive: true }
      );
    });

    /* Momentum after the finger lifts, and the tail of a trackpad flick, both
       arrive as scroll events with nothing to mark their end. While paused,
       every one of them defers the restart. */
    track.addEventListener(
      'scroll',
      function () {
        if (paused) scheduleResume();
      },
      { passive: true }
    );

    /* Same rule for a trackpad: sideways means them, downwards means the page
       going past. */
    track.addEventListener(
      'wheel',
      function (event) {
        if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) {
          pauseAuto();
          scheduleResume();
        }
      },
      { passive: true }
    );

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              startAuto();
            } else {
              clearTimeout(resumeTimer);
              stopAuto();
            }
          });
        },
        { threshold: 0.25 }
      ).observe(section);
    } else {
      startAuto();
    }

    /* Widening past the point where all five fit takes the copies back out of
       the flow, so a desktop shows five centred clips rather than ten. */
    window.addEventListener('resize', function () {
      if (canSlide()) {
        startAuto();
      } else {
        stopAuto();
        track.classList.remove('video-reels__track--looping');
        track.scrollLeft = 0;
      }
    });

    /* Arrows scroll by one clip. Measured off the rendered item rather than a
       hardcoded width, so it stays right across the breakpoints. */
    var prev = section.querySelector('[data-reels-prev]');
    var next = section.querySelector('[data-reels-next]');
    if (!prev || !next) return;

    var syncArrows = function () {
      var max = track.scrollWidth - track.clientWidth - 1;
      prev.disabled = track.scrollLeft <= 0;
      next.disabled = track.scrollLeft >= max;
    };

    prev.addEventListener('click', function () {
      pauseAuto();
      track.scrollBy({ left: -step(), behavior: reduced ? 'auto' : 'smooth' });
      scheduleResume();
    });

    next.addEventListener('click', function () {
      pauseAuto();
      track.scrollBy({ left: step(), behavior: reduced ? 'auto' : 'smooth' });
      scheduleResume();
    });

    track.addEventListener('scroll', syncArrows, { passive: true });
    window.addEventListener('resize', syncArrows);
    syncArrows();
  });
})();

/* Elori — theme.js: country and currency selector */
(function () {
  'use strict';

  document.querySelectorAll('[data-locale-form]').forEach(function (form) {
    var select = form.querySelector('[data-locale-select]');
    if (!select) return;

    /* Marking the form is what hides the submit button, so it only disappears
       once this handler is genuinely attached. Hiding it in CSS up front would
       leave a dead control if the script never ran. */
    form.setAttribute('data-locale-enhanced', '');

    select.addEventListener('change', function () {
      if (form.requestSubmit) {
        form.requestSubmit();
      } else {
        form.submit();
      }
    });
  });
})();

/* Elori — theme.js: inline clips play only while on screen */
(function () {
  'use strict';

  /* Every one of these ships preload="none" and shows a poster until it is
     scrolled to. Without this they would either autoplay off-screen — pulling
     megabytes nobody sees, and asking a phone to decode several streams behind
     a viewport showing one — or need tapping, which for a silent looping clip
     is a control with no purpose.

     Reduced motion keeps the poster and never starts playback. */
  var clips = document.querySelectorAll(
    '.video-reels__player, .image-with-text__video, [data-inline-video]'
  );
  if (!clips.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var watcher = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target;
        if (entry.isIntersecting) {
          var attempt = video.play();
          /* Rejects when the browser declines autoplay. Nothing to be done
             about it, but it must not surface as an unhandled rejection. */
          if (attempt && attempt.catch) attempt.catch(function () {});
        } else {
          video.pause();
        }
      });
    },
    { threshold: 0.4 }
  );

  clips.forEach(function (video) {
    /* Belt and braces: iOS only honours inline playback with both of these
       present as attributes, and Liquid's video_tag drops them depending on
       the source. */
    video.muted = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    watcher.observe(video);
  });
})();

/* Elori — theme.js: the same gift rule on the cart page
   ------------------------------------------------------------------
   The drawer enforces this as it renders, but /cart is server-rendered and
   the drawer's code never runs there. Without this, removing one gift on the
   cart page leaves the other two charged — the exact overcharge the rule
   exists to prevent, reachable by taking one step sideways.

   Reads the cart once on load and acts only if something is actually wrong,
   so an ordinary cart costs one request and no reload. */
(function () {
  'use strict';

  if (!document.querySelector('[data-cart-guard]') || !window.fetch) return;

  var isGift = function (item) {
    return !!(item.properties && item.properties._gift);
  };

  fetch('/cart.js', { headers: { Accept: 'application/json' } })
    .then(function (response) {
      return response.json();
    })
    .then(function (cart) {
      var gifts = cart.items.filter(isGift);
      if (!gifts.length) return;

      var orphaned = cart.items.filter(function (item) {
        return !isGift(item);
      }).length === 0;
      var charged = gifts.some(function (item) {
        return item.final_line_price > 0;
      });
      if (!orphaned && !charged) return;

      /* By key: each removal renumbers the lines after it, so indexes taken
         before the first call are wrong by the second. */
      gifts
        .map(function (item) {
          return item.key;
        })
        .reduce(function (chain, key) {
          return chain.then(function () {
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: key, quantity: 0 })
            });
          });
        }, Promise.resolve())
        .then(function () {
          window.location.reload();
        })
        .catch(function () {});
    })
    .catch(function () {});
})();
